import styled from 'styled-components';
import palette from 'lib/styles/palette';
import ContractTable from 'components/contract/ContractTable';
import useContractList from 'hooks/contract/useContractList';

const ContractList = () => {
  const { search, onChange, onMove } = useContractList();

  return (
    <ContractListBlock>
      <Header>
        <div className="title">계약 등록 / 조회</div>
        <StyledInput
          type="text"
          name="search"
          placeholder="소속, 담당자를 입력해 주세요"
          value={search}
          onChange={onChange}
        />
        <button onClick={onMove}>신규 계약 등록</button>
      </Header>
      <ContractTable />
    </ContractListBlock>
  );
};

export default ContractList;

const ContractListBlock = styled.div`
  width: 1080px;
  margin: 0 auto;
`;

const Header = styled.div`
  margin-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .title {
    font-size: 22px;
    font-weight: bold;
  }
  button {
    padding: 10px 20px;
    border: none;
    border-radius: 50px;
    background: ${palette.theme[3]};
    color: #fff;
    cursor: pointer;
    :hover {
      background: ${palette.theme[2]};
    }
  }
`;

const StyledInput = styled.input`
  width: 600px;
  height: 40px;
  border-radius: 11px;
  border: solid 1px #dfdfdf;
  background: #fff;
  padding: 15px;
  font-size: 16px;
  &::placeholder {
    color: #c6c6c6;
  }
  & + & {
    margin-top: 15px;
  }
`;
